SCHEMA_SERIES_LINK